/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SweaterInputs */

const en_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweater`)
};

const es_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suéter`)
};

const fr_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pull`)
};

const de_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pullover`)
};

const ja_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セーター`)
};

const zh_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毛衣`)
};

const ar_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سترة`)
};

const id_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweter`)
};

const it_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maglione`)
};

const ru_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свитер`)
};

const pt_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suéter`)
};

const ko_val_sweater = /** @type {(inputs: Val_SweaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스웨터`)
};

/**
* | output |
* | --- |
* | "Sweater" |
*
* @param {Val_SweaterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sweater = /** @type {((inputs?: Val_SweaterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SweaterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sweater(inputs)
	if (locale === "es") return es_val_sweater(inputs)
	if (locale === "fr") return fr_val_sweater(inputs)
	if (locale === "de") return de_val_sweater(inputs)
	if (locale === "ja") return ja_val_sweater(inputs)
	if (locale === "zh") return zh_val_sweater(inputs)
	if (locale === "ar") return ar_val_sweater(inputs)
	if (locale === "id") return id_val_sweater(inputs)
	if (locale === "it") return it_val_sweater(inputs)
	if (locale === "ru") return ru_val_sweater(inputs)
	if (locale === "pt") return pt_val_sweater(inputs)
	return ko_val_sweater(inputs)
});